import TransferBySerial from '@/api/stock/transfer-by-serial'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    edit_data: {},
    transfer_type: 'transfered',
    status_id: 1,
    location_id: null,
    dateRange: null
}

export const getters = {
}

export const mutations = {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
        state.edit_data = data
    },
    SET_BRANCHES(state, data) {
        state.branches = data
    },
    SET_SERIAL_STATUS(state, data) {
        state.serialStatus = data
    },
    SET_TRANSFER_TYPE(state, data) {
        state.transfer_type = data
    },
    SET_DATE_RANGE(state, date) {
        state.dateRange = date
    },
    SET_STATUS_ID(state, data) {
        state.status_id = data
    },
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                location_id: context.state.location_id,
                filter: {
                    search: context.state.search,
                    date_between: _.join(context.state.dateRange, ','),
                    transfer_type: context.state.transfer_type,
                    status_id: context.state.status_id
                }
            },
            attrubutes
        )
        return TransferBySerial.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },

    confirm(context, data) {
        return TransferBySerial.updateStatus(data)
    },

    reject(context, data) {
        return TransferBySerial.updateStatus(data)
    },


    async find(context, id) {
        if (_.isEmpty(context.state.edit_data)) {
            let response = await TransferBySerial.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },

    printPdf(context, attribute = {}) {
        return TransferBySerial.printPdf({ params: attribute })
    },
    async checkReceiveMonthDiffMonthTransfer(context, data) {
        return await TransferBySerial.checkReceiveMonthDiffMonthTransfer(data)
    },
    exportExcel(context, data) {
        return TransferBySerial.exportExcel(data)
    }
}
